/* eslint-disable @typescript-eslint/no-explicit-any, camelcase */

/**
 * This file is autogenerated, please don't edit it manually.
 * Use this command to regenerate it if you modified Epic experiments:
 * yarn epic:types
 */

/**
 * Epic experiments namespaces with their possible keys.
 * Autogenerated from static/bundles/epic/data/defaults/
 */
import client from 'bundles/epic/client';
import GrowthDiscovery from 'bundles/epic/data/defaults/GrowthDiscovery.json';
import type { Tags } from 'bundles/epic/lib/EpicTypes';

type Namespace = {
  fullStoryBrowseEnabled: boolean;
  enablePendoForGateways: boolean;
  showEvolveCollection: boolean;
  showEvolveCollectionBrowse: boolean;
  showBiggerCTAonXDP: boolean;
  cSerpProductCardDensitySkills: boolean;
  cSerpProductCardDensityRating: boolean;
  showRecentlyUpdatedBadge: boolean;
  showCPlusCtaOnGenAiHubPage: 'control' | 'a';
  showUpdatedNoResultsPage: boolean;
  showBrowseInSerp: boolean;
  enableSelfServePageFullStory: boolean;
  showNewSERPSuggestedSearch: boolean;
  productCardLeftVsRight: 'control' | 'B' | 'C';
  enableGenAiCollection: boolean;
  coachInSearch: 'control' | 'B';
  showLearningProductCard: boolean;
  cmsProxyBffEnabled: boolean;
  enableSelfServeCampaigns: boolean;
  enableAiReviews: boolean;
  enableBrowseV2: boolean;
  enableBrowseSkillPages: boolean;
  showSearchBannerOnLOHP: boolean;
  enableXDPRedesignPhase1: boolean;
  enableXDPRedesignKIM: boolean;
  enableXDPRedesignHero: boolean;
  enableXDPRedesignDescriptionRework: boolean;
  enableXDPRedesignClickableSkills: boolean;
  disableXDPThinBanner: boolean;
  enableLOHPRedesignHeroCTAOptimization: boolean;
  enableSelfServeFrontPageRedesign: boolean;
  enableEnterpriseHomeProfileBar: boolean;
  enableConsumerLearningPreview: boolean;
  enableTargetingStrategyInputForCampaign: boolean;
  removeC4bCtaFromLohpHero: boolean;
  aiRecapOnHome: boolean;
  isDefaultFAQsForFreemiumEnabled: boolean;
  showLearnerObjectPathways: boolean;
  enableXDPRedesignPhase2: 'control' | 'B' | 'C';
  coachCareerFitAssistantOnXdp: 'control' | 'B' | 'C';
  shouldShowAiAssistanceOnLOHPForSignupAbandonment: boolean;
  shouldShowAiAssistanceOnLOHPForProductDecision: boolean;
  showFindBetterFit: boolean;
  promoBarBannerColourExperiment:
    | 'control'
    | 'experimental-color-blue-abstract-gradient'
    | 'experimental-color-pink-abstract-gradient'
    | 'primary-blue-xxstrong'
    | 'experimental-color-expressive-yellow';
  enableDegreesInHeader: boolean;
  enablePathwaysForAll: boolean;
  enableCardTakeoverExperiment: boolean;
};

const NAMESPACE = 'GrowthDiscovery';

// Adding safe optional chaining to avoid massive changes in unit tests.
client.addDefaults?.([GrowthDiscovery as $TSFixMe]);

const GrowthDiscoveryEpicClient = {
  get<K extends keyof Namespace>(key: K, tags?: Tags): Namespace[K] {
    return client.get(NAMESPACE, key, tags);
  },

  preview<K extends keyof Namespace>(key: K, tags?: Tags, defaults?: Namespace): Namespace[K] {
    return client.preview(NAMESPACE, key, tags);
  },
};

export default GrowthDiscoveryEpicClient;
